export function isDescendantOrSelf(node, ancestor) {
  return !node || !ancestor
    ? false
    : node === ancestor
      ? true
      : isDescendantOrSelf(node.parentNode, ancestor)
}
